module.exports = __webpack_public_path__ + "static/media/loader.efb2d9db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/loader.gif
// module id = 218
// module chunks = 0